import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import SelectFCAndChannelForm from '../../components/SelectFCAndChannelForm'
import SelectedChannelsTable from '../../components/SelectedChannelsTable'
import StockAddressingFileInput from '../../components/StockAddressingFileInput'
import SubmitFileForm from '../../components/SubmitFileForm'
import InvalidStructureTable from '../../components/InvalidStructureTable'
import { actions } from '../../StockAddressingInBatchState'
import * as S from './StockAddressingInBatchPage.styles'
import DownloadCsvButton from '../../components/DownloadCsvButton'
import DownloadTemplate from 'src/features/base/components/DownloadTemplate'

export default () => {
  const dispatch = useDispatch()

  useEffect(() => () => {
    dispatch(actions.resetUploadPage())
  }, [dispatch])

  return (
    <S.Wrapper>
      <S.Title>Endereçamento de Estoque por Planilha</S.Title>
      <DownloadTemplate
        href='/addressing_template.xlsx'
      />
      <S.FormWrapper>
        <StockAddressingFileInput />
        <SelectFCAndChannelForm />
        <SelectedChannelsTable />
        <InvalidStructureTable />
        <SubmitFileForm />
        <DownloadCsvButton />
      </S.FormWrapper>
    </S.Wrapper>
  )
}
